export default __webpack_public_path__ + "static/media/gradle.77c65ea1.svg";